import React from 'react'
import styled from 'styled-components'
import { Trash } from '@styled-icons/boxicons-regular/Trash'

const WrapperIcon = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
`

const TrashStyled = styled(Trash)`
  color: red;
  cursor: pointer;
`

export const TrashButton = ({ handleClick }) => (
  <WrapperIcon>
    <TrashStyled onClick={handleClick} size={18} />
  </WrapperIcon>
)